<template>
  <div>
    <!--================================= NAVIGATION START ==========================================-->
    <header>
      <nav
        class="topbar navbar navbar-default navbar-fixed-top clearfix"
        id="top-nav"
      >
        <div class="container">
          <div class="logo-image" style="width:150px; height:50px">
            <img
              src="../assets/images/logoRevolvaWhite.gif"
              alt="150x50"
              class="img-responsive"
            />
          </div>
          <div class="navbar-right nav">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#bs-example-navbar-collapse-1"
                aria-expanded="false"
              >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div
              class="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
            >
              <div class="collapse navbar-collapse">
                <ul class="nav navbar-nav" id="menu_1">
                  <li class="menu">
                    <a href="#home" class="pagescroll">
                      {{ $t("menuBar.home") }}
                    </a>
                  </li>
                  <li class="menu">
                    <a href="#services" class="pagescroll">
                      {{ $t("menuBar.services") }}
                    </a>
                  </li>
									<li class="menu">
										<a href="#clients" class="pagescroll">
										{{ $t("menuBar.clients") }}
										</a>
									</li>
                  <!--
									<li class="menu">
										<a href="#news" class="pagescroll">
										News
										</a>
									</li>
									-->
                  <li class="menu">
                    <a href="#contact" class="pagescroll">
                      {{ $t("menuBar.contact") }}
                    </a>
                  </li>
                  <li>
                    <div class="clear">
                      <div class="dropdown">
                        <button
                          class="button-drop-down dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                        >
                          {{ $i18n.locale }} <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu text-right">
                          <li class="dropdown-li">
                            <button
                              class="dropdown-item"
                              @click="changeLocale('en')"
                            >
                              en
                            </button>
                          </li>
                          <li class="dropdown-li">
                            <button
                              class="dropdown-item"
                              @click="changeLocale('fr')"
                            >
                              fr
                            </button>
                          </li>
                          <li class="dropdown-li">
                            <button
                              class="dropdown-item"
                              @click="changeLocale('ar')"
                            >
                              ar
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /.navbar-collapse -->
        </div>
      </nav>
    </header>
    <!--================================= NAVIGATION END ==========================================-->
    <!--=================================  HEADER-1 START ==========================================-->
    <header>
      <div class="header-bgimage-1 bgimage-property clearfix" id="home">
        <div class="container">
          <div class="col-sm-12 header-div-1 header-padding text-center">
            <!--<h1>{{ $t('revolva') }}</h1>
						<p class="second-para">{{ $t('revolva_mission') }}</p>-->
            <img
              class="img-responsive"
              src="../assets/images/gif-dark-revolva.gif"
              style="margin: auto;"
              alt="150x50"
            />
            <!--	<div class="header-btn">
							<a href="#" class="btn btn-1">{{ $t('read_more') }}</a>
						</div> -->
          </div>
        </div>
      </div>
    </header>
    <!--================================= HEADER-1 ENDS ============================================-->

    <!--================================= SERVICE-1 START ==========================================-->
    <section class="section-padding bgimage-property" id="services">
      <div class="container">
        <div class="heading-div-1 text-center">
          <h2>{{ $t("services.title") }}</h2>
          <div class="underline"></div>
        </div>

        <div class="row display-flex">
          <div
            class="three-col section-space text-center services-space-2 services-space-3 onecolumn-res"
          >
            <div class="services-div">
              <img
                src="../assets/images/3d2.svg"
                alt="48x48x1"
                class="image-bottom-space1"
              />
              <h5>
                <a href="#">{{ $t("services.service1") }}</a>
              </h5>
              <p class="content-top-space1">
                {{ $t("services.service1_info") }}
              </p>
            </div>
          </div>
          <!--
          <div
            class="col-xs-4 three-col section-space  text-center services-space-2 services-space-3 onecolumn-res"
          >
            <div class="services-div">
              <img
                src="../assets/images/web.svg"
                alt="48x48x2"
                class="image-bottom-space1"
              />
              <h5>
                <a href="#">{{ $t("services.service2") }}</a>
              </h5>
              <p class="content-top-space1">
                {{ $t("services.service2_info") }}
              </p>
            </div>
          </div>-->
          <!--
          <div
            class="col-xs-4 three-col section-space  text-center services-space-2 services-space-3 onecolumn-res"
          >
            <div class="services-div">
              <img
                src="../assets/images/data.svg"
                alt="48x48x3"
                class="image-bottom-space1"
              />
              <h5>
                <a href="#">{{ $t("services.service3") }}</a>
              </h5>
              <p class="content-top-space1">
                {{ $t("services.service3_info") }}
              </p>
            </div>
          </div>-->
          <!--
							<div class="col-xs-6 col-sm-6 col-md-3 text-center  services-space-1 services-space-2 onecolumn-res">
								<div class="services-div">
									<img src="../assets/images/48x48x4.png" alt="48x48x4" class="image-bottom-space1"/>
									<h5><a href="#">Branding</a></h5>
									<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. </p>
								</div>
							</div>
							<div class="col-xs-6 col-sm-6 col-md-3 text-center services-space services-space-1 services-space-2 onecolumn-res">
								<div class="services-div">
									<img src="../assets/images/48x48x5.png" alt="48x48x5" class="image-bottom-space1"/>
									<h5><a href="#">Responsive</a></h5>
									<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. </p>
								</div>
							</div>
							<div class="col-xs-6 col-sm-6 col-md-3 text-center services-space services-space-1 services-space-2 onecolumn-res">
								<div class="services-div">
									<img src="../assets/images/48x48x6.png" alt="48x48x6" class="image-bottom-space1"/>
									<h5><a href="#">Testing</a></h5>
									<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. </p>
								</div>
							</div>
							<div class="col-xs-6 col-sm-6 col-md-3 text-center services-space services-space-2 onecolumn-res">
								<div class="services-div">
									<img src="../assets/images/48x48x7.png" alt="48x48x7" class="image-bottom-space1"/>	
									<h5><a href="#">App</a></h5>
									<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. </p>
								</div>
							</div>
							<div class="col-xs-6 col-sm-6 col-md-3 text-center services-space onecolumn-res">
								<div class="services-div">
									<img src="../assets/images/48x48x8.png" alt="48x48x8" class="image-bottom-space1"/>
									<h5><a href="#">Support</a></h5>
									<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. </p>
								</div>
							</div>
							-->
        </div>
      </div>
    </section>
    <!--================================= SERVICE-1 ENDS ==========================================-->

    <!--================================= THREE COLUMN START ==========================================-->
    <!--	
		<section class="section-padding section-2-bg">
			<div class="container">
				<div class="heading-div-1 text-center">
					<h2>Our Business Approach</h2>
					<div class="underline"></div>
				</div>
				<div class="row">
					<div class="col-sm-4 three-col section-space">
						<div class="three-img">
							<img src="../assets/images/750x500x1.jpg" alt="750x500x1" class="img-responsive"/>
						</div>
						<div class="three-col-div">
							<h4>Business Consulting</h4>
							<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit.</p>
							<div class="btn-top-space">
								<a href="#" class="btn btn-1">Read More</a>
							</div>
						</div>
					</div>
					<div class="col-sm-4 three-col section-space">
						<div class="three-img">
							<img src="../assets/images/750x500x2.jpg" alt="750x500x2" class="img-responsive"/>
						</div>
						<div class="three-col-div" >
							<h4>Awesome Support</h4>
							<div class="hide-content">
								<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit.</p>
								<div class="btn-top-space">
									<a href="#" class="btn btn-1">Read More</a>
								</div>
							</div>
						</div>
						
					</div>
					<div class="col-sm-4 three-col">
						<div class="three-img">
							<img src="../assets/images/750x500x3.jpg" alt="750x500x3" class="img-responsive"/>
						</div>
						<div class="three-col-div">
							<h4>Business Promotion</h4>
							<p class="content-top-space1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit.</p>
							<div class="btn-top-space">
								<a href="#" class="btn btn-1">Read More</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		-->
    <!--================================= THREE COLUMN ENDS ==========================================-->

    <!--================================= COUNTER START ==========================================-->
    <!--
		<div class="counter-bgimage bgimage-property">
			<div class="container">
				<div class="row counter-div">					
					<div class="col-xs-6 col-sm-3 col-md-3 text-center counter-space">					
						<p class="counter-value"><span class="count">2330</span></p>
						<p class="counter-title">Projects</p>
					</div>
					<div class="col-xs-6 col-sm-3 col-md-3 text-center counter-space1">						
						<p class="counter-value"><span class="count">2200</span></p>
						<p class="counter-title">CLIENTS</p>
					</div>
					<div class="col-xs-6 col-sm-3 col-md-3 text-center">					
						<p class="counter-value"><span class="count">1000</span></p>
						<p class="counter-title">AWARDS</p>
					</div>
					<div class="col-xs-6 col-sm-3 col-md-3 text-center">						
						<p class="counter-value"><span class="count">3000</span></p>
						<p class="counter-title">Likes</p>
					</div>
				</div>
			</div>
		</div>
		-->
    <!--================================= COUNTER ENDS ==========================================-->

    <!--================================= FEATURES-1 START ==========================================-->
    <!--		
		<section class="section-padding section-1-bg">
			<div class="container">
				<div class="heading-div-1 text-center">
					<h2>Our Features</h2>
					<div class="underline"></div>
				</div>
				<div class="row">
					<div class="col-sm-12 col-md-6 col-md-push-6 features-image res-space">
						<img src="../assets/images/555x590.jpg" alt="555x590" class="img-responsive" /> 
					
						<iframe src="https://s3.eu-west-3.amazonaws.com/ali.ch/index.html" width="555" height="590" ></iframe>

					</div>
					<div class="col-sm-12 col-md-6 col-md-pull-6 features-col">
						<ul class="list-ul content-ul">
							<li class="content-li">
								<div class="list-div">
									<div class="list-div-left">
										<img src="../assets/images/48x48x9.png" alt="48x48x9"/>
									</div>
									<div class="list-div-body">
										<h4><a href="#">24x7 Premium Support</a></h4>
										<p class="content-top-space-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla.
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. 
											Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla.  </p>
									</div>
								</div>
							</li>
							
							<li class="content-li">
								<div class="list-div">
									<div class="list-div-left">
										<img src="../assets/images/48x48x10.png" alt="48x48x10"/>
									</div>
									<div class="list-div-body">
										<h4><a href="#">70+ Domain Expertise</a></h4>
										<p class="content-top-space-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla.  </p>
									</div>
								</div>
							</li>
							<li class="content-li">
								<div class="list-div">
									<div class="list-div-left">
										<img src="../assets/images/48x48x11.png" alt="48x48x11"/>
									</div>
									<div class="list-div-body">
										<h4><a href="#">100+ Happiest Clients</a></h4>
										<p class="content-top-space-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla.  </p>
									</div>
								</div>
							</li>
							<li class="content-li">
								<div class="list-div">
									<div class="list-div-left">
										<img src="../assets/images/48x48x12.png" alt="48x48x12"/>
									</div>
									<div class="list-div-body">
										<h4><a href="#">Accurate Tracking &amp; Reporting</a></h4>
										<p class="content-top-space-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla.  </p>
									</div>
								</div>
							</li>
							
						</ul>
					</div>
				</div>
			</div>
		</section>
		-->
    <!--================================= FEATURES-1 ENDS ==========================================-->

    <!--================================= TWO COLUMN LEFT AND RIGHT START ==========================================-->

    <section class="section-padding bgimage-property">
      <div class="container">
        <div class="heading-div-1 text-center">
          <h2>{{ $t("products.title") }}</h2>
          <div class="underline"></div>
        </div>

        <div class="heading-div-1">
          <h3>{{ $t("products.product1") }}</h3>
          <div class="underline-1"></div>
        </div>

        <div class="row display-flex justify-content-center">
          <div class="col-sm-6 two-col section-space">
            <p class="content-top-space">{{ $t("products.product1_info1") }}</p>

            <div class="btn-top-space">
              <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                $t("products.Email")
              }}</a>
            </div>
          </div>
          <div class="col-sm-6 two-col section-space">
            <iframe
              class="embed-responsive-item"
              style="min-width:100%;  min-height:400px"
              src="https://d2ljnaidbvddyv.cloudfront.net/chair3d1/2"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="heading-div-1">
          <h3>{{ $t("products.product2") }}</h3>
          <div class="underline-1"></div>
        </div>
        <div class="row display-flex justify-content-center">
          <div class="col-sm-6 two-col section-space">
            <iframe
              class="embed-responsive-item"
              style="min-width:100%;  min-height:400px"
              src="https://d2ljnaidbvddyv.cloudfront.net/bike3d1/0"
              allowfullscreen
            ></iframe>
          </div>

          <div class="col-sm-6 two-col section-space">
            <p class="content-top-space">{{ $t("products.product2_info1") }}</p>
            <p class="content-top-space">{{ $t("products.product2_info2") }}</p>
            <div class="btn-top-space">
              <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                $t("products.Email")
              }}</a>
            </div>
          </div>
        </div>
        <div class="heading-div-1">
          <h3>{{ $t("products.product3") }}</h3>
          <div class="underline-1"></div>
        </div>
        <div class="row display-flex justify-content-center">
          <div class="col-sm-6 two-col section-space">
            <p class="content-top-space">{{ $t("products.product3_info1") }}</p>
            <p class="content-top-space">{{ $t("products.product3_info2") }}</p>

            <div class="btn-top-space">
              <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                $t("products.Email")
              }}</a>
            </div>
          </div>
          <div class="col-sm-6 two-col section-space">
            <iframe
              class="embed-responsive-item"
              style="min-width:100%;  min-height:400px"
              src="https://d2ljnaidbvddyv.cloudfront.net/watch3d1/1"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
    <!--================================= TWO COLUMN LEFT AND RIGHT ENDS ==========================================-->

    <!--================================= GALLERY START ==============================================-->
    <!--
		<div class="gallery-padding section-1-bg gallery-section" id="gallery">
			<div class="container-fluid">
				<div class="heading-div-1 text-center">
					<h2>Our Awesome Gallery</h2>
					<div class="underline"></div>
				</div>
				<div class="row">
					<ul class="filter-options">
						<li class="active" data-group="all">All</li>
						<li data-group="development">Development</li>
						<li data-group="design">Design</li>
						<li data-group="branding">Branding</li>
						<li data-group="marketing">Marketing</li>
						<li data-group="graphic">Graphic Design</li>
					</ul>
				</div>
				<div id="grid" class="row popup-gallery gallery-div myShuffle">
					<div class="col-sm-3 col-xs-6 gallery-col gallery-space picture-item" data-groups='["all","development", "graphic"]' >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x1.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x1.jpg" alt="520x480x1" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col  gallery-space picture-item" data-groups='["all","design", "graphic"]'>
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x2.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x2.jpg" alt="520x480x2" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>	
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col  gallery-space picture-item" data-groups='["all","development","marketing"]' >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x3.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x3.jpg" alt="520x480x3" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col gallery-space picture-item" data-groups='["all","design"]' >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x4.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x4.jpg" alt="520x480x4" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col gallery-row-2 picture-item" data-groups='["all","design","branding"]' >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x5.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x5.jpg" alt="520x480x5" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col gallery-row-2  picture-item" data-groups='["all","development", "marketing"]'>
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x6.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x6.jpg" alt="520x480x6" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col gallery-row-2  picture-item" data-groups='["all","development", "graphic"]'  >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x7.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x7.jpg" alt="520x480x7" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div class="col-sm-3 col-xs-6 gallery-col gallery-row-2 picture-item" data-groups='["all","design", "branding"]' >
						<div class="gallery-image picture-item__inner">
							<a href="../assets/images/520x480x8.jpg" title="Gallery">
								<div class="gallery-inner">
									<img src="../assets/images/520x480x8.jpg" alt="520x480x8" class="img-responsive" />
									<div class="gallery-caption">
										<i class="fa fa-search-plus" aria-hidden="true"></i>
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		-->
    <!--================================= GALLERY ENDS ==========================================-->

    <!--================================= TEAM START ==========================================-->
    <!-- <section class="section-padding section-2-bg">
      <div class="container">
        <div class="heading-div-1 text-center">
          <h2>{{ $t("Employees.title") }}</h2>
          <div class="underline"></div>
        </div>
        <div class="row text-center">
          <div class="col-sm-2 col-md-4 text-center"/>
          <div class="col-sm-4 col-md-2 text-center">
            <div class="content" style="margin: auto; margin-top:20px">
              <img
                src="../assets/images/Ali.jpg"
                style="margin: auto;width:200px; height:200px"
                alt="360x400x1"
                class="mx-auto img-responsive img-circle"
              />

              <h4 style="margin-top:10px">{{ $t("Employees.Emp1_name") }}</h4>
              <p>{{ $t("Employees.Emp1_position") }}</p>
              <p>{{ $t("Employees.Emp1_skill1") }}</p>
              <p>{{ $t("Employees.Emp1_skill2") }}</p>
            </div>
          </div>
          <div class="col-sm-4 col-md-2 text-center">
            <div class="content" style="margin: auto; margin-top:20px">
              <img
                src="../assets/images/Reem.jpg"
                alt="360x400x2"
                style="margin: auto; width:200px; height:200px"
                class="img-responsive img-circle"
              />
            </div>
            <h4 style="margin-top:10px">{{ $t("Employees.Emp2_name") }}</h4>
            <p>{{ $t("Employees.Emp2_position") }}</p>
            <p>{{ $t("Employees.Emp2_skill1") }}</p>
          </div>
         
          <div class="col-sm-2 col-md-4 text-center"/>
        </div>
      </div>
    </section> -->
    <!--================================= TEAM ENDS ==========================================-->

    <!--=================================  TESTIMONIAL START ==========================================-->
    <!--	
		<section class="section-padding testimonial-bg bgimage-property" id="testimonial">
			<div class="container">
				<div class="col-sm-12 text-center">
					<h2>Our Testimonial</h2>
					<div class="underline"></div>
					<div class="owl-carousel testimonial" >
						<div class="item">
							<div class="testimonial-div">
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x1.png"  alt="80x80x1"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">Lara Emily</p>
											<p class="testimonial-name1">Senior Developer</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
								
								
							</div>
						</div>
						<div class="item">
							<div class="testimonial-div">								
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x2.png"  alt="80x80x2"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">John Doe</p>
											<p class="testimonial-name1">Manager</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
							</div>
						</div>
						<div class="item">
							<div class="testimonial-div">								
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x3.png"  alt="80x80x3"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">Mark David</p>
											<p class="testimonial-name1">Developer</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
							</div>
						</div>
						<div class="item">
							<div class="testimonial-div">								
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x4.png"  alt="80x80x4"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">Carol</p>
											<p class="testimonial-name1">Team Leader</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
							</div>
						</div>
						<div class="item">
							<div class="testimonial-div">								
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x5.png"  alt="80x80x5"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">Daisy John</p>
											<p class="testimonial-name1">CEO</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
							</div>
						</div>
						<div class="item">
							<div class="testimonial-div">								
								<div class="testimonial-name-div">
									<div class="list-div">
										<div class="list-div-left">
											<img src="../assets/images/80x80x6.png"  alt="80x80x6"/>
										</div>
										<div class="list-div-body">
											<p class="testimonial-name">Katherine</p>
											<p class="testimonial-name1">Designer</p>
										</div>
									</div>
								</div>
								<p class="testimonial-para">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur."
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		-->
    <!--================================= TESTIMONIAL ENDS ============================================-->

    <!--================================= PRICE TABLE-1 START ==========================================-->
    <!--
    <section class="section-padding section-2-bg" id="pricing">
      <div class="container">
        <div class="heading-div-1 text-center">
          <h2>{{ $t("prices.title") }}</h2>
          <div class="underline"></div>
        </div>
        <div class="heading-div-1 text-center">
          <h4>{{ $t("prices.service1") }}</h4>
          <div class="underline"></div>
        </div>
        <div class="row ">
          <div class="col-sm-6 col-md-4 res-space" style="height: 100%; margin-top:20px;">
            <div class="price-line">
              <div class="price-table-col price-line-1 price-line-common light">
                <div class="price-line-2 price-line-common light">
                  <div class="price-head text-center">
                    <h4>{{ $t("prices.service1_product1") }}</h4>
                    <div class="price-table-content">
                      <p class="pt-price">
                        {{ $t("prices.service1_product1_price")
                        }}<span>{{
                          $t("prices.service1_product1_price_detail")
                        }}</span>
                      </p>
                    </div>
                    <!- <p class="pt-price">$30  <span>/ month</span></p>--><!--
                  </div>
                  <div class="price-inner text-center">
                    <ul class="price-table-content content-ul">
                      <li>
                        <p>{{ $t("prices.service1_product1_charc1") }}</p>
                      </li>
                      <!-
											<li>
												<p>Visualize+Customize</p>
												<p class="pt-price">100 Fr <span>/ month</span></p>
											</li>
											--><!--
                      <li>
                        <p>{{ $t("prices.service1_product1_charc2") }}</p>
                      </li>
                      <li>
                        <p>{{ $t("prices.service1_product1_charc3") }}</p>
                        <p class="pt-price">
                          {{ $t("prices.service1_product1_charc3_price") }}
                          <span>{{
                            $t("prices.service1_product1_charc3_price_detail")
                          }}</span>
                        </p>
                      </li>
                      <!-
											<li>
												<p>Animation and Custom Functions</p>
												<p><span>not specified (it depends on multiple factors)</span></p>
											</li>
											
											<li>
												<p>No Free <span>Squirel</span> </p>
											</li>
											--><!--
                    </ul>
                    <div class="pricing-btn">
                      <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                        $t("products.Email")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-4 res-space  " style="height: 100%; margin-top:20px;">
            <div class="price-line">
              <div class="price-table-col price-line-1 price-line-common light">
                <div class="price-line-2 price-line-common light">
                  <div class="price-head-1 text-center">
                    <h4>{{ $t("prices.service1_product2") }}</h4>
                    <div class="price-table-content">
                      <p class="pt-price">
                        {{ $t("prices.service1_product2_price") }}
                        <span>{{
                          $t("prices.service1_product2_price_detail")
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="price-inner text-center">
                    <ul class="price-table-content content-ul">
                      <li>
                        <p>{{ $t("prices.service1_product1_charc1") }}</p>
                      </li>
                      <li>
                        <p style="color: #8B0000;">
                          {{ $t("prices.service1_product2_charc1") }}
                        </p>
                      </li>
                      <li>
                        <p>{{ $t("prices.service1_product1_charc2") }}</p>
                      </li>

                      <li>
                        <p>{{ $t("prices.service1_product1_charc3") }}</p>
                        <p class="pt-price">
                          {{ $t("prices.service1_product1_charc3_price") }}
                          <span>{{
                            $t("prices.service1_product1_charc3_price_detail")
                          }}</span>
                        </p>
                      </li>
                      <!-
											<li>
												<p>Animation and Custom Functions</p>
												<p><span>not specified (it depends on multiple factors)</span></p>
											</li>
											
											<li>
												<p>No Free <span>Squirel</span> </p>
											</li>
											--><!--
                    </ul>
                    <div class="pricing-btn-1">
                      <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                        $t("products.Email")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-4 col-lg-0 res-space "/>
          <div class="col-sm-6 col-md-4 res-space" style="height: 100%; margin-top:20px">
            <div class="price-line">
              <div class="price-table-col price-line-1 price-line-common light">
                <div class="price-line-2 price-line-common light">
                  <div class="price-head text-center">
                    <h4>{{ $t("prices.service1_product3") }}</h4>
                    <div class="price-table-content">
                      <p class="pt-price">
                        <span>{{
                          $t("prices.service1_product3_price_detail")
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="price-inner text-center">
                    <ul class="price-table-content content-ul">
                      <li>
                        <p>{{ $t("prices.service1_product1_charc1") }}</p>
                      </li>
                      <li>
                        <p style="color: #8B0000;">
                          {{ $t("prices.service1_product2_charc1") }}
                        </p>
                      </li>

                      <li>
                        <p style="color: #8B0000;">
                          {{ $t("prices.service1_product3_charc1") }}
                        </p>
                      </li>
                      <li>
                        <p>{{ $t("prices.service1_product1_charc2") }}</p>
                      </li>
                      <li>
                        <p>{{ $t("prices.service1_product1_charc3") }}</p>
                        <p class="pt-price">
                          {{ $t("prices.service1_product1_charc3_price") }}
                          <span>{{
                            $t("prices.service1_product1_charc3_price_detail")
                          }}</span>
                        </p>
                      </li>
                      <!-
											<li>
												<p>No Free <span>Squirel</span> </p>
											</li>
											--><!--
                    </ul>
                    <div class="pricing-btn">
                      <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                        $t("products.Email")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-4 res-space"/>
        </div>

        <div class="row" style="margin-top: 40px">
          <div class="heading-div-1 text-center">
            <h4>{{ $t("prices.service2") }}</h4>
            <div class="underline"></div>
          </div>
          <div class="col-md-2 res-space"/>
          <div class="col-sm-6 col-md-4 res-space">
            <div class="price-line">
              <div class="price-table-col price-line-1 price-line-common light">
                <div class="price-line-2 price-line-common light">
                  <div class="price-head text-center">
                    <h4>{{ $t("prices.service2_product1") }}</h4>
                    <div class="price-table-content">
                      <p class="pt-price">
                        {{ $t("prices.service2_product1_price") }}
                        <span>{{
                          $t("prices.service2_product1_price_detail")
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="price-inner text-center">
                    <ul class="price-table-content content-ul">
                      <li>
                        <p>{{ $t("prices.service2_product1_charc1") }}</p>
                      </li>

                      <li>
                        <p>
                          {{ $t("prices.service2_product1_charc2")
                          }}<span>{{
                            $t("prices.service2_product1_charc2_detail")
                          }}</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          {{ $t("prices.service2_product1_charc3") }}
                          <span>{{
                            $t("prices.service2_product1_charc3_detail")
                          }}</span>
                        </p>
                      </li>
                      <!-
											<li>
												<p>Forum <span>Support</span> </p>
											</li>
											<li>
												<p>No Free <span>Squirel</span> </p>
											</li>
											--><!--
                    </ul>
                    <div class="pricing-btn">
                      <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                        $t("products.Email")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="price-line">
              <div class="price-table-col price-line-1 price-line-common light">
                <div class="price-line-2 price-line-common light">
                  <div class="price-head text-center">
                    <h4>{{ $t("prices.service2_product2") }}</h4>
                    <div class="price-table-content">
                      <p class="pt-price">
                        {{ $t("prices.service2_product2_price") }}
                        <span>{{
                          $t("prices.service2_product2_price_detail")
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="price-inner text-center">
                    <ul class="price-table-content content-ul">
                      <li>
                        <p>{{ $t("prices.service2_product2_charc1") }}</p>
                      </li>

                      <li>
                        <p>
                          {{ $t("prices.service2_product2_charc2")
                          }}<span>{{
                            $t("prices.service2_product2_charc2_detail")
                          }}</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          {{ $t("prices.service2_product2_charc3") }}
                          <span>{{
                            $t("prices.service2_product2_charc3_detail")
                          }}</span>
                        </p>
                      </li>
                    </ul>
                    <div class="pricing-btn">
                      <a href="mailto:info@revolva.ch" class="btn btn-1">{{
                        $t("products.Email")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 res-space"/>
        </div>
      </div>
    </section>-->
    <!--================================= PRICE TABLE-1 ENDS ==========================================-->

    <!--=================================  CTA START ==========================================-->
    <!--	
		<section class="cta-bg bgimage-property">
			<div class="container">
				<div class="col-sm-12 text-center">
					<h2>Call To Action</h2>
					<div class="underline"></div>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
								Lorem ipsum dolor sit amet consectetur.
					</p>
					<div class="btn-top-space">
						<a href="#" class="btn btn-1">Read More</a>
					</div>
				</div>
			</div>
		</section>
		-->
    <!--================================= CTA ENDS ============================================-->

    <!--================================= NEWS START ==========================================-->
    <!--	
		<section class="section-padding section-1-bg" id="news">
			<div class="container">
				<div class="heading-div-1 text-center">
					<h2>Our News</h2>
					<div class="underline"></div>
				</div>
				<div class="row news-row-1">
					<div class="col-sm-4">
						<div class="news-img">
							<img src="../assets/images/360x225x1.jpg" alt="360x225x1" class="img-responsive"/>	
						</div>
					</div>
					<div class="col-sm-8">
						<div class="news-col">
						<ul class="content-ul news-ul">
							<li><a href="#"><img src="../assets/images/24x24x1.png" alt="24x24x1"/></a></li>
							<li>
								<p><a href="#">Mar 24, 2017</a></p>
							</li>
						</ul>
						<h4><a href="#">Word Startup Meeting</a></h4>
						
						<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien. 
						</p>
						<div class="content-top-space">
							<a href="#" class="readmore1">Read More <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>	
						</div>
						</div>
					</div>
					
				</div>
				
				<div class="row news-row-2">
					<div class="col-sm-4 col-sm-push-8">
						<div class="news-img">
							<img src="../assets/images/360x225x2.jpg" alt="360x225x2" class="img-responsive"/>	
						</div>
					</div>
					<div class="col-sm-8 col-sm-pull-4">
						<div class="news-col">
						<ul class="content-ul news-ul">
							<li><a href="#"><img src="../assets/images/24x24x1.png" alt="24x24x1"/></a></li>
							<li>
								<p><a href="#">Mar 24, 2017</a></p>
							</li>
						</ul>
						<h4><a href="#">Word Startup Meeting</a></h4>
						
						<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
						</p>
						<div class="content-top-space">
							<a href="#" class="readmore1">Read More <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>	
						</div>
						</div>
					</div>
					
				</div>
				
			</div>
		</section>
		-->
    <!--================================= NEWS ENDS ==========================================-->

    <!--================================= SPONSORS-2 START ==========================================-->

		<div class="section-2-bg section-padding" id="clients">
			<div class="container">
				<div class="heading-div-1 text-center">
					<h2>{{ $t("clients.title") }}</h2>
					<div class="underline"></div>
				</div>
				<div class="row client-row">
					<div class="col-xs-3 col-sm-3 clients-res-space onecolumn-res clients-res-space1">
						<img src="../assets/images/lombard-01.svg" alt="280x200x1" class="img-responsive" />	
					</div>
					<div class="col-xs-3 col-sm-3 clients-res-space onecolumn-res clients-res-space1">
						<img src="../assets/images/cefori-01.svg" alt="280x200x2" class="img-responsive" />	
					</div>
					<div class="col-xs-3 col-sm-3 onecolumn-res clients-res-space1">
						<img src="../assets/images/ID-01.svg" alt="280x200x3" class="img-responsive" />		
					</div>
					<div class="col-xs-3 col-sm-3 onecolumn-res">
						<img src="../assets/images/ipcoaching-01.svg" alt="280x200x4" class="img-responsive" />	
					</div>
          <div class="col-xs-3 col-sm-3 onecolumn-res">
						<img src="../assets/images/swiss_eco_bags_logo_white.svg" alt="280x200x4" class="img-responsive" />	
					</div>
				</div>
			</div>
		</div>
    <!--================================= SPONSORS-2 ENDS ==========================================-->

    <!--================================= HEADER STRIP START ==========================================-->
    <!--
		<div class="header-strip-bg bgimage-property">
			<div class="container">
				<div class="row strip-row">
					<div class="col-sm-12 col-md-9">
						<h3>Awesome MultiPurpose Template</h3>
						<p class="first-para">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae semper nulla. Nunc tempus consequat blandit. Sed nec risus sapien.
							Lorem ipsum dolor sit amet. 
						</p>
					</div>
					<div class="col-sm-12 col-md-3">
						<div class="strip-btn">
							<a href="#" class="btn btn-1">Buy Now</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		-->
    <!--================================= HEADER STRIP END ==========================================-->

    <!--================================= FORM SECTION START ==========================================-->

    <div class="section-padding section-2-bg" id="contact">
      <div class="container">
        <div class="heading-div-1 text-center">
          <h2>{{ $t("subscribe.title") }}</h2>
          <div class="underline"></div>
        </div>
        <div class="row text-center">
          <div class="col-sm-12" id="canvas1">
            <!-- Begin Mailchimp Signup Form -->
            <div id="mc_embed_signup">
              <form
                action="https://revolva.us8.list-manage.com/subscribe/post?u=f2e1f2d8873e0ef764b876034&amp;id=3c6acd865e"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div id="mc_embed_signup_scroll">
                  <div class="mc-field-group">
                    <div class="row centered">
                      <div class="col-xs-3" />
                      <div class="col-xs-12 col-sm-6">
                        <div class="row">
                          <div class="col-xs-12 col-sm-8 contact-address-space">
                            <input
                              type="email"
                              value=""
                              name="EMAIL"
                              class="required form-control"
                              id="mce-EMAIL"
                              v-bind:placeholder="$t('subscribe.email-text')"
                              required
                            />
                          </div>
                          <div class="col-xs-12 col-sm-4 contact-address-space">
                            <input
                              type="submit"
                              v-bind:value="$t('subscribe.button-text')"
                              name="subscribe"
                              id="mc-embedded-subscribe"
                              class="btn btn-danger subscribe-button"
                              style="color: white;"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-3" />
                    </div>
                  </div>
                  <div
                    class="mc-field-group"
                    aria-hidden="true"
                    style="display:none"
                  >
                    <label for="mce-LANGUAGE">language</label>
                    <input
                      type="text"
                      :value="$i18n.locale"
                      name="LANGUAGE"
                      class=""
                      id="mce-LANGUAGE"
                    />
                  </div>
                  <div id="mce-responses" class="clear">
                    <div
                      class="response"
                      id="mce-error-response"
                      style="display:none"
                    ></div>
                    <div
                      class="response"
                      id="mce-success-response"
                      style="display:none"
                    ></div>
                  </div>
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_f2e1f2d8873e0ef764b876034_3c6acd865e"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                </div>
              </form>
            </div>

            <!--End mc_embed_signup-->
          </div>
        </div>
      </div>
    </div>

    <!--================================= FORM SECTION ENDS ==========================================-->

    <!--================================= FOOTER-1 START ==========================================-->
    <div class="footer-section section-padding">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 footer-col">
            <div class="footer-logo">
              <a href="#"
                ><img
                  src="../assets/images/LogoRevolva.png"
                  alt="250x80"
                  class="img-responsive"
              /></a>
            </div>
            <h4>{{ $t("about.title") }}</h4>
            <p>{{ $t("about.desc") }}</p>
          </div>
          <div class="col-sm-4 footer-col-1">
            <!--
					<div id="mc_embed_signup" class="subscribe-form">
							<h4>Subscribe Here</h4>
							<form  action="http://evethemes.us11.list-manage.com/subscribe/post?u=a795532c55a578843e04b09c0&amp;id=fa362f029a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate form7 clearfix"  novalidate>
														
									<input class="subscribe-input" type="email" name="EMAIL"  value="" id="mce-EMAIL" placeholder="Please Enter Email">
									<div class="subscribe-btn">
									<button class="btn btn-1" id="mc-embedded-subscribe" type="submit">
                    Subscribe
									</button>
									</div>
							
								<div id="mce-responses">
									<div class="response response-msg" id="mce-error-response"></div>
									<div class="response response-msg" id="mce-success-response"></div>
								</div>
							</form>
							<div id="ResultMsg" class="message">
								<p class="SuccessMsg"></p>
								<p class="FailureMsg"></p>
							</div>
						</div>
						-->
          </div>
          <div class="col-sm-4">
            <div class="contact-div">
              <ul class="content-ul contact-address contact-address-space">
                <li>
                  <img src="../assets/images/32x32x5.png" alt="32x32x5" />
                </li>
                <li>
                  <p><a href="#">info@revolva.ch</a></p>
                </li>
              </ul>
              <ul class="content-ul contact-address contact-address-space">
                <li>
                  <img src="../assets/images/32x32x6.png" alt="32x32x6" />
                </li>
                <li>
                  <p>Av. General Guisan 1800 Vevey</p>
                </li>
              </ul>
              <ul class="content-ul contact-address contact-address-space">
                <li>
                  <img src="../assets/images/32x32x7.png" alt="32x32x7" />
                </li>
                <li>
                  <p><a href="#">www.revolva.ch</a></p>
                </li>
              </ul>
              <ul class="content-ul contact-address">
                <li>
                  <img src="../assets/images/32x32x8.png" alt="32x32x8" />
                </li>
                <li>
                  <p>+41 77 507 3767</p>
                </li>
              </ul>
            </div>
            <ul class="content-ul footer1-icon">
              <!--
              <li>
                <a href="#"
                  ><img src="../assets/images/40x40x1.png" alt="40x40x1"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/images/40x40x2.png" alt="40x40x2"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/images/40x40x3.png" alt="40x40x3"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/images/40x40x4.png" alt="40x40x4"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/images/40x40x5.png" alt="40x40x5"
                /></a>
              </li>
              -->
              <li>
                <a href="https://www.linkedin.com/company/revolvach"
                  ><img width="40" height="40" src="../assets/images/40x40x6.png" alt="40x40x6"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--================================= FOOTER-1 END ==========================================-->

    <!--================================= COPYRIGHT-1 START ==========================================-->
    <footer class="copyright-bg">
      <div class="container copyright text-center">
        <p>{{ new Date().getFullYear() }} &copy; All Rights Reserved</p>
      </div>
    </footer>
  </div>
</template>

<script>
import i18n from "@/i18n";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    },
  },
};
</script>

<style lang="scss" scoped>
.subscribe-button {
  color: white !important;
}
.subscribe-button:hover {
  color: black !important;
}

.button-drop-down {
  background-color: Transparent !important;
  background-repeat: no-repeat !important;
  color: #aaa !important;
  border: none !important;
  cursor: pointer !important;
  overflow: hidden !important;
  outline: none !important;
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.navbar-right .dropdown-menu {
  background-color: Transparent !important;
  background-repeat: no-repeat !important;
  color: #aaa !important;
  border: none !important;
  cursor: pointer !important;
  overflow: hidden !important;
  outline: none !important;
  min-width: 50px !important;
}

.dropdown-menu {
  width: 50px !important;
    box-shadow: none !important;
}

.dropdown-li {
  width: 50px !important;
    box-shadow: none !important;
}

.dropdown-item {
  width: 50px !important;
  color: #aaa !important;
  font-weight: 400 !important;
  background-color: #313131 !important;
  border-top: none !important;
  border-right: none !important;
  border-left:none !important;
  margin-bottom: 10px !important;
  border-bottom-color: red !important;

}
</style>
